import Immutable from 'immutable';

const _initState = {
    areaList: [],     //区域
    deviceList: [],   //区域下设备
    paramsList:[],   //设备下参数
};

export function QueryArea(status, data) {
    return status.set("areaList", Immutable.fromJS(data));
}
export function QueryDevice(status, data) {
    return status.set("deviceList", Immutable.fromJS(data));
}
export function QueryParams(status, data) {
    return status.set("paramsList", Immutable.fromJS(data));
}


const REDUCER_TABLE = {};
REDUCER_TABLE['device.QueryArea'] = QueryArea;
REDUCER_TABLE['device.QueryDevice'] = QueryDevice;
REDUCER_TABLE['device.QueryParams'] = QueryParams;

export default {
    REDUCER_TABLE,
    initialState: _initState
};
